// Wait for DOM content to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
    // Get share button element
    const sharePageButton = document.querySelector('#sharePageButton');

    // Check if share button exists and Web Share API is supported
    if (sharePageButton && navigator.share) {
        // Add click event listener to share button
        sharePageButton.addEventListener('click', async () => {
            try {
                // Attempt to share page using Web Share API
                await navigator.share({
                    title: document.title,
                    text: "Рекомендую переглянути цю сторінку!",
                    url: window.location.href
                });
                console.log("Стаття успішно надіслана!");
            } catch (error) {
                // Log any errors that occur during sharing
                console.error("Помилка Web Share API:", error);
            }
        });
    }
});
